<template>
<div class="pt-2 text-start">
    <div class="row bg-light mb-2">
        <div class="col-2"></div>
        <div class="col">
        <div class="input-group input-group-sm mb-1" title="ป้อนคำเพื่อค้นหาจากชื่อ นามสกุลและเลขบัตรประชาชน / Passport No.">
            <div class="input-group-prepend">
            <span class="input-group-text fs-3" style="width:140px;">คำค้นหา :</span>
            </div>
            <input type="text" class="form-control form-control-sm fs-3 fw-bold" placeholder="ป้อนคำค้นหา"
                name="findTextPatient" v-model="findTextPatient" v-on:keyup.enter="findPatients()">
            <button class="btn bg-transparent" style="margin-left: -40px; z-index: 100;" @click="findTextPatient=''">
                <i class="fa fa-times"></i>
            </button>
            <button type="button" class="btn btn-info fs-3 mx-1" style="width:100px;" @click="findPatients()">ค้นหา</button>
        </div>
        </div>
        <div class="col-2"></div>
    </div>
    <table id="myFindPatientTable" class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
        <thead class="text-white" style="background:Navy">
        <tr>
            <th>คำนำหน้า</th>
            <th>ชื่อ</th>
            <th>นามสกุล</th>
            <th>เลขบัตรปชช.</th>
            <th>จังหวัด</th>
            <th>ประเทศ / พาสปอร์ต</th>
            <th>คำสั่ง</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in dataPatientFindlists" :key="item.PatID">
            <td class="text-start">{{ item.PrefixName }}</td>
            <td class="text-start">{{ item.PatName }}</td>
            <td class="text-start">{{ item.PatLName }}</td>
            <td class="text-start">{{ item.IDNo }}</td>
            <td class="text-start">{{ item.Province }}</td>
            <td class="text-start">{{ item.Country }} / {{ item.PassportNo }}</td>
            <td  >
                <button type="button" class="btn btn-info btn-sm" data-bs-dismiss="modal"
                    id="add" @click="selectPatient(item)">เลือก</button>
            </td>
        </tr>
        </tbody>
    </table>
</div>
</template>

<script>
// import axios from 'axios'
// import myfuncs from '../myjs/myfuncs.js'
// import funcRO from '../myjs/funcRO.js'
import { MyApiClient } from '../myjs/my-api-client.js'
// // ****** Bootstrap and jQuery libraries ******
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// // ****** Datatable Modules *******
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'modelFindPatient',
  data () {
    return {
      // รายชื่อคนไข้เดิมที่ค้นหาจากคำค้นหา ใน Modal
      findTextPatient: '',
      dataPatientFindlists: []
    }
  },
  props: [],
  mounted () {
  },
  components: {

  },
  computed: {
  },
  methods: {
    selectPatient (row) {
      this.$emit('onBackPageAfterSelectPatientEvent', row)
    //   this.curRecordHd.PatID = row.PatID
    //   this.curRecordHd.PatName = row.PatName
    //   this.curRecordHd.PatLName = row.PatLName
    },
    findPatients () {
      if (this.findTextPatient === '') {
        Swal.fire({ icon: 'error', text: 'กรุณาป้อนคำค้นหาอย่างน้อย 1 ตัวอักษร' })
        return
      }
      MyApiClient.get('getdata/patient_like.php?C1=' + this.globalCorpID + '&findText=' + this.findTextPatient)
        .then((resp) => {
          this.dataPatientFindlists = resp.data.response
          $('#myFindPatientTable').DataTable().destroy()
          setTimeout(function () { $('#myFindPatientTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
